export const menuItemsPersonal = [
    {
        id: 1,
        label: "menuitems.dashboards.text",
        icon: "bx-home-circle",
        link: "/"
    },
    {
        id: 2,
        label: "menuitems.cards.text",
        icon: "bx-id-card",
        link: "/my-cards"
    },
    {
        id: 3,
        label: "menuitems.products.text",
        icon: "bx-shopping-bag",
        link: "/product"
    },
    {
        id: 4,
        label: "menuitems.events.text",
        icon: "bx-calendar-event",
        link: "/event"
    },
    {
        id: 5,
        label: "menuitems.banners.text",
        icon: "bx-image-alt",
        link: "/banner"
    }
];
